// extracted by mini-css-extract-plugin
module.exports = {"orderSim":"PaymentArrangementRequest_orderSim__3JgRz","titleWrapper":"PaymentArrangementRequest_titleWrapper__25-pT","title":"PaymentArrangementRequest_title__2Lk0c"};